<!-- Template -->

<template>
    <footer>
        <div class="container pl-0 pr-0">
            <p>&copy; {{year}} Vision RT Ltd. All Rights Reserved.</p>
        </div>
    </footer>     
</template>

<!-- Script -->

<script>
    import moment from 'moment';
    export default {
        name: 'Footer',

        data(){
            return{
                year: moment().format('YYYY')
            }
        }
    }
</script>

